import { Component } from '@angular/core';

@Component({
  selector: 'app-public-content',
  imports: [],
  templateUrl: './public-content.html',
  styleUrl: './public-content.scss'
})
export class PublicContent {

}
